import { noop } from 'lodash';

export const loadExternalScriptToDOM = async (
  scriptURL: string | undefined,
  scriptId: string,
  scriptInnerHtml?: string
) => {
  const scriptElement = document.querySelector(`script[id="${scriptId}"]`);

  if (scriptElement) {
    return noop();
  }
  return new Promise<void>(resolve => {
    const script = document.createElement('script');
    script.id = scriptId;
    script.type = 'text/javascript';
    script.async = true;

    if (scriptURL) {
      script.onload = () => resolve();
      script.src = scriptURL;
    } else if (scriptInnerHtml) {
      script.innerHTML = scriptInnerHtml;
    }

    document.head.appendChild(script);

    if (scriptInnerHtml) {
      resolve();
    }
  });
};
